import React from 'react'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import InfoIcon from '@material-ui/icons/Info'
import filter from 'lodash/filter'
import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import toLower from 'lodash/toLower'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import GetContentType, { CONTENT_TYPE_HTML } from 'drawer/tabs/info/panels/ContentType'
import IconAboutCalendarRange from 'drawer/tabs/layers/about/IconAboutCalendarRange'
import IconAboutDatabase from 'drawer/tabs/layers/about/IconAboutDatabase'
import IconAboutDomain from 'drawer/tabs/layers/about/IconAboutDomain'
import IconAboutFileTableOutline from 'drawer/tabs/layers/about/IconAboutFileTableOutline'
import IconAboutTextSubject from 'drawer/tabs/layers/about/IconAboutTextSubject'
import { ICON_COLOR_ENABLED, PANEL_TITLE_ABOUT } from 'drawer/tabs/layers/panels/LayerPanels'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import GetGeoJSON from 'drawer/tabs/layers/utils/GetGeoJSON'
import Downloader from 'drawer/tabs/tools/DownloadMap/Downloader'
import GeojsonToWKT from 'utils/GeojsonToWKT'
import { linkifyText, sanitiseHtml } from 'utils/url'

const mapLayerTypes = [
  { type: 'geojson', label: 'GeoJSON' },
  { type: 'imagewms', label: 'Image Web Map Service' },
  { type: 'qgisgetprojectsettings', label: 'QGIS ProjectSettings' },
  { type: 'tilewms', label: 'Web Map Tile Service (WMTS)' },
  { type: 'tilewmsauth', label: 'Web Map Tile Service (WMTS) (authenticated)' },
  { type: 'vicmap', label: 'Vicmap API (WMTS)' },
  { type: 'wfsgetcapabilities', label: 'WFS Capabilities' },
  { type: 'wms', label: 'Web Map Service (WMS)' },
  { type: 'wmts', label: 'Web Map Tile Service (WMTS)' },
  { type: 'wmsgetcapabilities', label: 'WMS Capabilities' },
  { type: 'wmtscapabilities', label: 'WMTS Capabilities' },
  { type: 'xyz', label: 'Web Map Tile Service (WMTS)' }
]

const styles = theme => ({
  root: {
    overflow: 'hidden',
    padding: 10
  },
  chipRoot: {
    margin: 0,
    marginLeft: 0,
    paddingBottom: 10,
    whiteSpace: 'inherit',
    height: 38
  },
  chipLabel: {
    paddingLeft: 20,
    whiteSpace: 'inherit'
  },
  chipIcon: {
    marginLeft: 0
  },
  cardContentHeader: {
    fontWeight: 'bold'
  },
  cardContent: {},
  learnMore: {
    padding: 10
  },
  chip: {
    backgroundColor: 'initial'
  },
  headingIcon: {
    color: ICON_COLOR_ENABLED,
    fill: ICON_COLOR_ENABLED
  },
  tableRow: {
    height: 'initial'
  },
  tableIcon: {
    color: ICON_COLOR_ENABLED,
    padding: 10,
    width: 30,
    borderBottom: 'inherit',
    verticalAlign: 'top'
  },
  tableLabel: {
    fontSize: 14,
    padding: 10,
    borderBottom: 'inherit'
  },
  table: {
    marginBottom: 10
  }
})

class LayerPanelAbout extends React.Component {
  constructor (props) {
    super(props)
    this.pure = {}
    this.pure.downloadGeoJSON = this.downloadGeoJSON.bind(this)
    this.pure.downloadWKT = this.downloadWKT.bind(this)
  }

  downloadGeoJSON () {
    const { titleid } = this.props
    console.log('downloadGeoJSON')
    const geojsonString = GetGeoJSON(titleid)
    const filename = titleid + '_' + moment().format('YYYYMMDDHHmmss') + '.geojson'
    Downloader(geojsonString, filename)
  }

  downloadWKT () {
    const { titleid } = this.props
    console.log('downloadWKT')
    const geojson = GetGeoJSON(titleid)
    const wkt = GeojsonToWKT(geojson)
    const filename = titleid + '_' + moment().format('YYYYMMDDHHmmss') + '.wkt'
    Downloader(wkt, filename)
  }

  getLayerLabelFromLayerType (layerType) {
    if (isNil(layerType) || layerType === '') {
      return ''
    }
    return filter(mapLayerTypes, function (o) {
      return toLower(o.type) === toLower(layerType)
    })
  }

  layoutMarkup (id, icon, text) {
    const { classes } = this.props

    if (!text) {
      return null
    }

    // Make any potential links clickable
    const linkifiedText = linkifyText(text)

    return (
      <TableRow className={classes.tableRow} key={id}>
        <TableCell className={classes.tableIcon} align="left">
          {icon}
        </TableCell>
        <TableCell className={classes.tableLabel} align="left">
          {linkifiedText}
        </TableCell>
      </TableRow>
    )
  }

  render () {
    const { classes, titleid, layerAbout, layerType, bBackClicked } = this.props

    const tableCellMarkup = []

    const sourceMarkup = this.layoutMarkup('source', <IconAboutDatabase />, get(layerAbout, 'source', ''))
    if (sourceMarkup) {
      tableCellMarkup.push(sourceMarkup)
    }

    const organisationMarkup = this.layoutMarkup('organisation', <IconAboutDomain />, get(layerAbout, 'organisation', ''))
    if (organisationMarkup) {
      tableCellMarkup.push(organisationMarkup)
    }

    const dateMarkup = this.layoutMarkup('date', <IconAboutCalendarRange />, get(layerAbout, 'date', ''))
    if (dateMarkup) {
      tableCellMarkup.push(dateMarkup)
    }

    const descriptionMarkup = this.layoutMarkup('description', <IconAboutTextSubject />, get(layerAbout, 'description', ''))
    if (descriptionMarkup) {
      tableCellMarkup.push(descriptionMarkup)
    }

    const typeAboutLabel = get(layerAbout, 'type', '')
    const typeAboutLabelExists = has(layerAbout, 'type')
    let typeMarkup = null
    if (typeAboutLabelExists && typeAboutLabel === '') {
      // Do not render type if about.type is an empty string.
    } else if (typeAboutLabelExists && typeAboutLabel !== '') {
      // Use the type label if defined.
      typeMarkup = this.layoutMarkup('type', <IconAboutFileTableOutline />, typeAboutLabel)
    } else {
      // Use the main type if neither is defined.
      const typeLabel = this.getLayerLabelFromLayerType(layerType)
      if (typeLabel.length === 1) {
        typeMarkup = this.layoutMarkup('type', <IconAboutFileTableOutline />, typeLabel[0].label)
      }
    }
    if (typeMarkup) {
      tableCellMarkup.push(typeMarkup)
    }

    let learnMoreMarkup = ''
    let url = get(layerAbout, 'url', '')
    if (url !== '') {
      const urlLabel = get(layerAbout, 'urltext', 'Learn More')
      if (urlLabel === '') {
        url = 'Learn More'
      }
      learnMoreMarkup = (
        <Button className={classes.learnMore} size="small" target="_blank" href={url}>
          {urlLabel}
        </Button>
      )
    }

    const markup = (
      <div className={classes.root}>
        <Table className={classes.table}>
          <TableBody>
            {tableCellMarkup.map(markup => {
              return markup
            })}
          </TableBody>
        </Table>
        {learnMoreMarkup}
      </div>
    )

    const icon = <InfoIcon className={classes.headingIcon} />
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_ABOUT} headerIcon={icon} markup={markup} bBackClicked={bBackClicked} />
  }
}

LayerPanelAbout.propTypes = {
  classes: PropTypes.object.isRequired,
  layerAbout: PropTypes.object,
  layerType: PropTypes.string.isRequired,
  titleid: PropTypes.string.isRequired,
  bBackClicked: PropTypes.bool
}

function mapStateToProps (state, ownProps) {
  const layerAbout = get(state, 'layers[' + ownProps.titleid + '].about', {})
  const layerType = get(state, 'layers[' + ownProps.titleid + '].type', '')
  return {
    layerAbout,
    layerType
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerPanelAbout)
  )
)
